import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Registracia.scss";

// components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Input from "../../coraWebComponents/forms/Input";
import MaskedTextBox from "../../coraWebComponents/forms/MaskedTextBox";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import Button from "../../coraWebComponents/buttons/Button";
import Recaptcha from "../Recaptcha";
import ErrorMsg from "../ErrorMsg";
import RadioGroup from "../../coraWebComponents/forms/RadioGroup";
import Checkbox from "../../coraWebComponents/forms/Checkbox";

// routes
import Routes from "../../constants/Routes";

// actions
import * as registerActions from "../../actions/registerActions";

class RegistraciaNextStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menoZiadatela: "",
      priezviskoZiadatela: "",
      nazovPravOsoby: "",
      ico: "",
      ulica: "",
      cs: null,
      co: "",
      obec: "",
      psc: undefined,
      mobil: "",
      gdpr: false,
      RCTOKEN: "",
      ErrText: "",
      radioValue: { label: "Fyzická osoba", value: "fyzOsoba" },
      radioData: [
        { label: "Fyzická osoba", value: "fyzOsoba" },
        { label: "Právnická osoba", value: "pravOsoba" },
      ],
      titles: {
        mobil: `Vložte Váš telefónny kontakt v zobrazenom tvare (buď 0904123456, alebo  +421904123456), 
          ktorý bude slúžiť na riešenie možných problémov pri registrácii.`,
        menoZiadatela: `Meno žiadateľa`,
        priezviskoZiadatela: `Priezvisko`,
        nazovPravOsoby: `Názov prav osoby`,
        ico: `IČO`,
        ulica: "Ulica",
        cs: "Číslo súpisné",
        co: "Číslo orientačné",
        obec: "Obec",
        psc: "PSČ",
        gdpr: "Žiadateľ týmto v zmysle GDPR udeľuje SITEL s.r.o. výslovný súhlas na zhromažďovanie, uchovávanie a spracovanie nevyhnutných osobných údajov na účely poskytnutia odpovede na túto žiadosť v rozsahu povinne vyplnených polí. Osobné údaje budú uchovanané po dobu registrácie. Žiadateľ má právo kedykoľvek v priebehu uchovávania údajov požiadať o ich zmenu alebo odstránenie. V prípade odstránenia osobných údajov zo systému, zaniká žiadateľovi registrácia."
      },
      showRegistrationForm: true,
    };
  }

  handleOnRegister = async (event) => {
    event.preventDefault();

    const { navigate, register, email, password } = this.props;
    const {
      nazovPravOsoby,
      ico,
      mobil,
      RCTOKEN,
      menoZiadatela,
      priezviskoZiadatela,
      ulica,
      cs,
      co,
      psc,
      obec,
      radioValue,
      gdpr
    } = this.state;

    if (RCTOKEN === "") {
      this.setState(() => ({ ErrText: "Zaškrtnite položku: Nie som robot!" }));
      return;
    }

    if (!gdpr) {
      this.setState(() => ({ ErrText: "Zaškrtnite položku: GDPR!" }));
      return;
    }

    const isFyzickaOsoba = radioValue.value === "fyzOsoba";
    await register(
      {
        email,
        password,
        nazovPravOsoby,
        ico,
        isFyzickaOsoba,
        menoZiadatela,
        priezviskoZiadatela,
        ulica,
        cs,
        co,
        psc,
        obec,
        mobil,
        RCTOKEN,
      },
      password === ""
    );

    setTimeout(() => {
      navigate(Routes.LOGIN);
      navigate(0);
    }, 8000);
  };
  handleOnChange = (name, value) => {
    this.setState({ [name]: value });
  };
  handleRecaptcha = (token) => {
    this.handleOnChange("RCTOKEN", token);
    this.setState(() => ({ ErrText: "" }));
  };

  render() {
    const { isLoading, email, onBack } = this.props;
    const {
      titles,
      nazovPravOsoby,
      ico,
      mobil,
      radioValue,
      radioData,
      menoZiadatela,
      priezviskoZiadatela,
      ulica,
      cs,
      co,
      obec,
      psc,
      gdpr
    } = this.state;

    return (
      <div className="row m-0">
        <div className="col-4 offset-4 p-0 registrationForWeb">
          <div className="card registration">
            <div className="card-body">
              <div className="card-title">
                <h1>Registrácia</h1>
              </div>

              <Tooltip>
                <form className="k-form" onSubmit={this.handleOnRegister}>
                  <div className="k-form-field">
                    <span>Email</span>
                    <Input
                      type="email"
                      name="email"
                      onChange={this.handleOnChange}
                      value={email}
                      disabled
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <RadioGroup
                      textField="label"
                      dataItemKey="value"
                      value={radioValue}
                      data={radioData}
                      name="radioValue"
                      layout="horizontal"
                      onChange={this.handleOnChange}
                    />
                  </div>

                  <div
                    className="k-form-field flexGroup"
                    style={{ marginTop: "0px" }}
                  >
                    {radioValue.value === "fyzOsoba" && (
                      <>
                        <div
                          className="k-form-field flex1"
                          style={{ padding: "0px 5px 0px 0px" }}
                        >
                          <span>{"*Meno žiadateľa"}</span>
                          <Input
                            title={titles.menoZiadatela}
                            type="text"
                            name="menoZiadatela"
                            onChange={this.handleOnChange}
                            value={menoZiadatela}
                            required
                          />
                        </div>
                        <div
                          className="k-form-field flex1"
                          style={{
                            padding: "0px 0px 0px 5px",
                          }}
                        >
                          <span>{"*Priezvisko"}</span>
                          <Input
                            title={titles.priezviskoZiadatela}
                            type="text"
                            name="priezviskoZiadatela"
                            onChange={this.handleOnChange}
                            value={priezviskoZiadatela}
                            required
                          />
                        </div>
                      </>
                    )}
                    {radioValue.value !== "fyzOsoba" && (
                      <>
                        <div
                          className="k-form-field flex1"
                          style={{ padding: "0px 5px 0px 0px" }}
                        >
                          <span>{"*Názov"}</span>
                          <Input
                            title={titles.nazovPravOsoby}
                            type="text"
                            name="nazovPravOsoby"
                            onChange={this.handleOnChange}
                            value={nazovPravOsoby}
                            required
                          />
                        </div>
                        <div
                          className="k-form-field flex1"
                          style={{
                            padding: "0px 0px 0px 5px"
                          }}
                        >
                          <span>{"*IČO"}</span>
                          <Input
                            title={titles.ico}
                            type="text"
                            name="ico"
                            onChange={this.handleOnChange}
                            value={ico}
                            required
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="k-form-field">
                    <span>{"Ulica:"}</span>
                    <Input
                      title={titles.ulica}
                      type="text"
                      name="ulica"
                      value={ulica}
                      onChange={this.handleOnChange}
                    />
                  </div>

                  <div
                    className="k-form-field flexGroup"
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      className="k-form-field flex1"
                      style={{ padding: "0px 5px 0px 0px" }}
                    >
                      <span>{"*ČS:"}</span>
                      <Input
                        title={titles.cs}
                        type="number"
                        name="cs"
                        value={cs}
                        onChange={this.handleOnChange}
                        required
                      />
                    </div>

                    <div
                      className="k-form-field flex1"
                      style={{ padding: "0px 0px 0px 5px" }}
                    >
                      <span>{"ČO:"}</span>
                      <Input
                        title={titles.co}
                        type="text"
                        name="co"
                        value={co}
                        onChange={this.handleOnChange}
                      />
                    </div>
                  </div>

                  <div
                    className="k-form-field flexGroup"
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      className="k-form-field flex1"
                      style={{ padding: "0px 5px 0px 0px" }}
                    >
                      <span>{"*PSČ:"}</span>
                      <MaskedTextBox
                        title={titles.psc}
                        name="psc"
                        value={psc}
                        onChange={this.handleOnChange}
                        mask="000 00"
                        required
                      />
                    </div>
                    <div
                      className="k-form-field flex2"
                      style={{ padding: "0px 0px 0px 5px" }}
                    >
                      <span>{"*Obec:"}</span>
                      <Input
                        title={titles.obec}
                        type="text"
                        name="obec"
                        value={obec}
                        onChange={this.handleOnChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="k-form-field">
                    <span>{"*Telefónny kontakt"}</span>
                    <Input
                      title={titles.mobil}
                      type="tel"
                      name="mobil"
                      onChange={this.handleOnChange}
                      placeholder="+421999999999"
                      pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                      validationMessage="Nesprávny formát telefónneho čísla"
                      value={mobil}
                      required
                    />
                  </div>
                  <div className="k-form-field" title={titles.gdpr}>
                    <Checkbox
                      name="gdpr"
                      value={gdpr}
                      label={"Súhlasím s GDPR"}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <div className="footerContainer">
                      <Button
                        primary={true}
                        disabled={isLoading}
                        label="Späť"
                        onClick={onBack}
                      />
                      <Button
                        primary={true}
                        disabled={isLoading}
                        label="Registrovať"
                        type="submit"
                      />
                    </div>
                  </div>

                  <Recaptcha
                    id="recaptcha"
                    onChange={this.handleRecaptcha}
                  />
                  {this.state.ErrText && <ErrorMsg text={this.state.ErrText} />}
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="col registrationForMobile">
          <div className="card registration">
            <div className="card-body">
              <div className="card-title">
                <h1>Registrácia</h1>
              </div>
              <Tooltip>
                <form className="k-form" onSubmit={this.handleOnRegister}>
                  <div className="k-form-field">
                    <span>Email</span>
                    <Input
                      type="email"
                      name="email"
                      onChange={this.handleOnChange}
                      value={email}
                      disabled
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <RadioGroup
                      textField="label"
                      dataItemKey="value"
                      value={radioValue}
                      data={radioData}
                      name="radioValue"
                      layout="horizontal"
                      onChange={this.handleOnChange}
                    />
                  </div>
                  {radioValue.value === "fyzOsoba" && (
                    <>
                      <div className="k-form-field">
                        <span>{"*Meno žiadateľa"}</span>
                        <Input
                          title={titles.menoZiadatela}
                          type="text"
                          name="menoZiadatela"
                          onChange={this.handleOnChange}
                          value={menoZiadatela}
                          required
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"*Priezvisko"}</span>
                        <Input
                          title={titles.priezviskoZiadatela}
                          type="text"
                          name="priezviskoZiadatela"
                          onChange={this.handleOnChange}
                          value={priezviskoZiadatela}
                          required
                        />
                      </div>
                    </>
                  )}
                  {radioValue.value !== "fyzOsoba" && (
                    <>
                      <div className="k-form-field">
                        <span>{"*Názov"}</span>
                        <Input
                          title={titles.nazovPravOsoby}
                          type="text"
                          name="nazovPravOsoby"
                          onChange={this.handleOnChange}
                          value={nazovPravOsoby}
                          required
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"*IČO"}</span>
                        <Input
                          title={titles.ico}
                          type="text"
                          name="ico"
                          onChange={this.handleOnChange}
                          value={ico}
                          required
                        />
                      </div>
                    </>
                  )}

                  <div className="k-form-field">
                    <span>{"*Ulica:"}</span>
                    <Input
                      title={titles.ulica}
                      type="text"
                      name="ulica"
                      value={ulica}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"*ČS:"}</span>
                    <Input
                      title={titles.cs}
                      type="text"
                      name="cs"
                      value={cs}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"*ČO:"}</span>
                    <Input
                      title={titles.co}
                      type="text"
                      name="co"
                      value={co}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field flex1">
                    <span>{"*PSČ:"}</span>
                    <MaskedTextBox
                      title={titles.psc}
                      name="psc"
                      value={psc}
                      onChange={this.handleOnChange}
                      mask="000 00"
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"*Obec:"}</span>
                    <Input
                      title={titles.obec}
                      type="text"
                      name="obec"
                      value={obec}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <span>{"*Telefónny kontakt"}</span>
                    <Input
                      title={titles.mobil}
                      type="tel"
                      name="mobil"
                      onChange={this.handleOnChange}
                      placeholder="+421999999999"
                      pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                      validationMessage="Nesprávny formát telefónneho čísla"
                      value={mobil}
                      required
                    />
                  </div>
                  <div className="k-form-field" title={titles.gdpr}>
                    <Checkbox
                      name="gdpr"
                      value={gdpr}
                      label={"Súhlasím s GDPR"}
                      onChange={this.handleOnChange}
                      required
                    />
                  </div>
                  <div className="k-form-field">
                    <div className="footerContainer">
                      <Button
                        primary={true}
                        disabled={isLoading}
                        label="Späť"
                        onClick={onBack}
                      />
                      <Button
                        primary={true}
                        disabled={isLoading}
                        label="Registrovať"
                        type="submit"
                      />
                    </div>
                  </div>

                  <Recaptcha
                    id="recaptcha"
                    onChange={this.handleRecaptcha}
                  />
                  {this.state.ErrText && <ErrorMsg text={this.state.ErrText} />}
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  register: (userData, google = false) =>
    dispatch(registerActions.register(userData, google)),
});

RegistraciaNextStep.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  register: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RegistraciaNextStep)
);
